export function getDestinationTemplate(url: string): string {
  return url.length ? `Web->{"target":"${url}"}` : 'None';
}
